import { render, staticRenderFns } from "./NotesToSelf.vue?vue&type=template&id=4feec8e6"
import script from "./NotesToSelf.vue?vue&type=script&lang=js"
export * from "./NotesToSelf.vue?vue&type=script&lang=js"
import style0 from "./NotesToSelf.vue?vue&type=style&index=0&id=4feec8e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports